import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

const FEATURES = [
  'ניתוח קבצי ZIP מהמסלקה הפנסיונית (מבנה אחיד 008)',
  'Dashboard — כל הקרנות, גרפים, סיכומים',
  'תחזית פרישה אינטראקטיבית (5 buckets)',
  'מילוי אוטומטי טופס 161 פיצויים',
  'קיבוע זכויות — כל מצבי הפרישה',
  'ייצוא דוח PDF + חתימה דיגיטלית',
  'OCR לטפסי סריקה',
  'תכנון פרישה מותאם אישית',
  'אסטרטגיות פרישה גמישות',
  'התאמה מלאה ללקוח',
  'גיבוי ושחזור נתונים',
  'אפשרות ל-🔒 פרטיות מלאה — הנתונים נשמרים אצלך בלבד, לא בענן לבחירתך',
  'ניסיון חינם 30 יום · ללא כרטיס אשראי',
];

// TODO: החלף במספר ה-WhatsApp האמיתי (בפורמט בינלאומי, ללא +)
const WHATSAPP_NUMBER = '972500000000';

export default function PricingPage({ onBack }) {
  const [billing, setBilling] = useState('annual');
  const { signInWithGoogle } = useAuth();

  const proPrice    = billing === 'monthly' ? 299 : 249;
  const proYearly   = billing === 'annual'  ? 249 * 12 : null;
  const yearlySave  = (299 - 249) * 12; // 600

  const waLink = (pkg) =>
    `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
      `שלום, מעוניין/ת בחבילת "${pkg}" של מסלקה פנסיונית`
    )}`;

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(180deg, #eef2ff 0%, #f8fafc 40%)',
      fontFamily: "'Segoe UI', -apple-system, sans-serif",
      direction: 'rtl',
      overflowY: 'auto',
      padding: '0 0 64px',
    }}>

      {/* ── Header ── */}
      <div style={{ textAlign: 'center', padding: '44px 20px 20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {/* Sophisticated Geometric Icon */}
        <div style={{
          width: 64,
          height: 64,
          borderRadius: '20px',
          background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: 16,
          boxShadow: '0 15px 30px -10px rgba(15, 23, 42, 0.4), inset 0 2px 4px rgba(255,255,255,0.1)'
        }}>
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="url(#goldGradPricing)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="miter">
            <defs>
              <linearGradient id="goldGradPricing" x1="0" y1="1" x2="1" y2="0">
                <stop offset="0%" stopColor="#b45309" />
                <stop offset="50%" stopColor="#fbbf24" />
                <stop offset="100%" stopColor="#fef3c7" />
              </linearGradient>
            </defs>
            <path d="M3 20 L8 4 L12 14 L16 4 L21 20" />
            <line x1="2" y1="20" x2="22" y2="20" strokeWidth="2.5"/>
          </svg>
        </div>
        
        {/* Logo Text - Unified & Elegant */}
        <div style={{
          fontSize: 48,
          fontWeight: 900,
          letterSpacing: '0.06em',
          fontFamily: "'Playfair Display', 'Cinzel', 'Georgia', serif",
          color: '#0f172a',
          margin: '0 0 8px',
          lineHeight: 1.1,
          direction: 'ltr'
        }}>
          MIVIDA
        </div>
        
        <style>{`
          @keyframes gradientShine {
            to { background-position: 200% center; }
          }
        `}</style>
        <p style={{ 
          fontSize: 15, 
          fontWeight: 700,
          margin: 0, 
          lineHeight: 1.6,
          background: 'linear-gradient(to right, #64748b 0%, #0f172a 20%, #4f46e5 40%, #d97706 60%, #64748b 100%)',
          backgroundSize: '200% auto',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text',
          color: 'transparent',
          animation: 'gradientShine 5s linear infinite'
        }}>
          מ-2 שעות ל-5 דקות לכל לקוח · ריבוי תכנונים והשוואה חכמה AI
        </p>
      </div>



      {/* ── Billing Toggle ── */}
      <div style={{ textAlign: 'center', marginBottom: 28 }}>
        <div style={{
          display: 'inline-flex',
          background: '#e2e8f0',
          borderRadius: 30,
          padding: 4,
        }}>
          {['monthly', 'annual'].map((b) => (
            <button
              key={b}
              onClick={() => setBilling(b)}
              style={{
                padding: '8px 22px',
                borderRadius: 26,
                border: 'none',
                cursor: 'pointer',
                fontWeight: 600,
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
                gap: 6,
                background: billing === b ? 'white' : 'transparent',
                color:      billing === b ? '#1e293b' : '#64748b',
                boxShadow:  billing === b ? '0 1px 4px rgba(0,0,0,0.12)' : 'none',
                transition: 'all 0.18s',
              }}
            >
              {b === 'monthly' ? 'חודשי' : 'שנתי'}
              {b === 'annual' && (
                <span style={{
                  background: '#22c55e', color: 'white',
                  fontSize: 10, fontWeight: 700,
                  padding: '2px 7px', borderRadius: 10,
                }}>
                  חסוך ₪{yearlySave}
                </span>
              )}
            </button>
          ))}
        </div>
      </div>

      {/* ── Pricing Cards ── */}
      <div style={{
        display: 'flex',
        gap: 20,
        maxWidth: 700,
        margin: '0 auto',
        padding: '0 20px',
        justifyContent: 'center',
        flexWrap: 'wrap',
        alignItems: 'flex-start',
      }}>

        {/* Per-Client Card (Anchor / Decoy) */}
        <div style={{
          flex: '1 1 250px',
          maxWidth: 300,
          background: 'white',
          borderRadius: 16,
          padding: '28px 24px',
          border: '1.5px solid #e2e8f0',
          boxShadow: '0 2px 12px rgba(0,0,0,0.05)',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
        }}>
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#94a3b8', letterSpacing: 1, margin: '0 0 8px', textTransform: 'uppercase' }}>
              לפי לקוח
            </p>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 42, fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>₪99</span>
              <span style={{ fontSize: 13, color: '#64748b' }}>+ מע״מ / לקוח</span>
            </div>
            <p style={{ fontSize: 13, color: '#64748b', margin: '8px 0 0', lineHeight: 1.5 }}>
              גמיש — משלמים רק על מה שמשתמשים
            </p>
          </div>

          <div style={{
            background: '#fef9c3', border: '1px solid #fde047',
            borderRadius: 8, padding: '8px 12px',
            fontSize: 12, color: '#854d0e',
          }}>
            💡 מ-4 לקוחות/חודש — <strong>Pro זול יותר</strong>
          </div>

          <ul style={{ margin: 0, padding: 0, listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 6 }}>
            {['כל תכונות המערכת', 'ללא התחייבות', 'ניסיון 30 יום חינם'].map(f => (
              <li key={f} style={{ fontSize: 13, color: '#374151', display: 'flex', gap: 7 }}>
                <span style={{ color: '#16a34a', fontWeight: 700 }}>✓</span>{f}
              </li>
            ))}
          </ul>

          <button
            onClick={() => window.open(waLink('לפי לקוח'), '_blank')}
            style={{
              marginTop: 'auto',
              padding: '11px 20px',
              background: 'white',
              color: '#1e293b',
              border: '1.5px solid #e2e8f0',
              borderRadius: 10,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 14,
              width: '100%',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
            onMouseLeave={e => e.currentTarget.style.background = 'white'}
          >
            📲 פנה אלינו
          </button>
        </div>

        {/* Pro Card (Hero) */}
        <div style={{
          flex: '1 1 270px',
          maxWidth: 340,
          background: 'white',
          borderRadius: 16,
          padding: '32px 26px 26px',
          border: '2.5px solid #4338ca',
          boxShadow: '0 8px 32px rgba(67,56,202,0.16)',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          gap: 14,
        }}>
          {/* Popular Badge */}
          <div style={{
            position: 'absolute', top: -13, right: 24,
            background: '#4338ca', color: 'white',
            fontSize: 11, fontWeight: 700,
            padding: '4px 14px', borderRadius: 20,
          }}>⭐ הכי פופולרי</div>

          <div>
            <p style={{ fontSize: 11, fontWeight: 700, color: '#4338ca', letterSpacing: 1, margin: '0 0 8px', textTransform: 'uppercase' }}>
              Pro
            </p>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 4, flexWrap: 'wrap' }}>
              <span style={{ fontSize: 48, fontWeight: 800, color: '#1e293b', lineHeight: 1 }}>₪{proPrice}</span>
              <span style={{ fontSize: 13, color: '#64748b' }}>+ מע״מ / חודש</span>
            </div>
            {billing === 'annual' ? (
              <p style={{ fontSize: 13, color: '#64748b', margin: '6px 0 0', lineHeight: 1.5 }}>
                ₪{proYearly?.toLocaleString()} + מע״מ לשנה
                <span style={{ color: '#16a34a', fontWeight: 700, marginRight: 8 }}>· חסוך ₪{yearlySave}</span>
              </p>
            ) : (
              <p style={{ fontSize: 13, color: '#64748b', margin: '6px 0 0' }}>
                לקוחות ללא הגבלה
              </p>
            )}
          </div>

          <button
            onClick={signInWithGoogle}
            style={{
              padding: '13px 20px',
              background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)',
              color: 'white',
              border: 'none',
              borderRadius: 10,
              cursor: 'pointer',
              fontWeight: 700,
              fontSize: 15,
              width: '100%',
              boxShadow: '0 4px 14px rgba(67,56,202,0.35)',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            🚀 התחל ניסיון חינם 30 יום
          </button>
          <p style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center', margin: '-6px 0 0' }}>
            ללא כרטיס אשראי · גישה מלאה לכל התכונות
          </p>

          <button
            onClick={() => window.open(waLink('Pro'), '_blank')}
            style={{
              padding: '10px 20px',
              background: 'transparent',
              color: '#4338ca',
              border: '1.5px solid #c7d2fe',
              borderRadius: 10,
              cursor: 'pointer',
              fontWeight: 600,
              fontSize: 13,
              width: '100%',
            }}
            onMouseEnter={e => e.currentTarget.style.background = '#eef2ff'}
            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
          >
            💬 שאלות? WhatsApp
          </button>
        </div>
      </div>

      {/* ── ROI Banner ── */}
      <div style={{
        background: '#1e3a8a',
        color: 'white',
        textAlign: 'center',
        padding: '11px 20px',
        fontSize: 13,
        fontWeight: 500,
        maxWidth: 680,
        margin: '36px auto 0',
        borderRadius: 10,
      }}>
        💡 יועץ עם 5 לקוחות בחודש משלם{' '}
        <strong>₪60 לניתוח</strong>{' '}
        — ומרוויח ₪4,500–9,000 לכל ייעוץ
      </div>

      {/* ── Privacy Banner ── */}
      <div style={{ textAlign: 'center', margin: '28px 20px 0' }}>
        <div style={{
          display: 'inline-block',
          background: '#f0fdf4', border: '1px solid #bbf7d0',
          borderRadius: 10, padding: '10px 20px',
          fontSize: 13, color: '#166534',
        }}>
          אפשרות ל-🔒 <strong>פרטיות מלאה</strong> — הנתונים נשמרים אצלך בלבד, לא בענן לבחירתך
        </div>
      </div>

      {/* ── Features List ── */}
      <div style={{ maxWidth: 620, margin: '36px auto 0', padding: '0 24px' }}>
        <h3 style={{
          textAlign: 'center', fontSize: 16, fontWeight: 700,
          color: '#1e293b', margin: '0 0 18px',
        }}>
          כל מה שכלול — בכל חבילה
        </h3>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))',
          gap: '9px 20px',
        }}>
          {FEATURES.map(f => (
            <div key={f} style={{ display: 'flex', alignItems: 'flex-start', gap: 8, fontSize: 13, color: '#374151' }}>
              <span style={{ color: '#16a34a', fontWeight: 700, flexShrink: 0, marginTop: 1 }}>✓</span>
              {f}
            </div>
          ))}
        </div>
      </div>

      {/* ── Back Button ── */}
      <div style={{ textAlign: 'center', marginTop: 44 }}>
        <button
          onClick={onBack}
          style={{
            background: 'white',
            border: '1.5px solid #cbd5e1',
            borderRadius: '12px',
            color: '#334155',
            cursor: 'pointer',
            fontSize: 15,
            fontWeight: 600,
            padding: '12px 24px',
            display: 'inline-flex',
            alignItems: 'center',
            gap: 8,
            boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
            transition: 'all 0.2s ease',
          }}
          onMouseEnter={e => {
            e.currentTarget.style.background = '#f8fafc';
            e.currentTarget.style.borderColor = '#94a3b8';
            e.currentTarget.style.transform = 'translateY(-1px)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.05)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.background = 'white';
            e.currentTarget.style.borderColor = '#cbd5e1';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 2px 4px rgba(0,0,0,0.05)';
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14" />
            <path d="m12 5 7 7-7 7" />
          </svg>
          חזרה למסך התחברות
        </button>
      </div>
    </div>
  );
}
